import { useNavigation } from '@react-navigation/native';

import { RootNavigationProp } from 'app/navigation/RootNavigator';

export default function useRootNavigation() {
  return useNavigation<RootNavigationProp>();
}
